import borders from './borders'
import colors from './colors'
import radius from './radius'
import shadows from './shadows'
import spacing from './spacing'
import iconsSize from './icons-size'
import {DeepPartial, SemanticsObject} from '../types/semantics.types'

const semanticOverrides: DeepPartial<SemanticsObject> = {
    colors: {
        text: {
            primary: colors['brand-primary'][100],
            tertiary: colors['brand-primary'][100],
        },
        background: {
            brand: colors['brand-primary'][100],
            'light-blue': colors['brand-primary'][60],
            red: colors['brand-secondary'][100],
            green: colors['brand-tertiary'][100],
            yellow: colors['brand-quaternary'][100],
        },
        label: {
            background: {
                primary: colors['brand-primary'][100],
                secondary: colors['brand-primary'][80],
            },
        },
        button: {
            text: {
                'secondary-default': colors['brand-primary'][100],
                'icon-default': colors['brand-primary'][100],
            },
            border: {'secondary-default': colors['brand-primary'][100]},
            background: {
                'secondary-default': colors['white'],
            },
        },
    },
}

export {borders, colors, radius, shadows, spacing, iconsSize, semanticOverrides}
